import { useState, useEffect } from "react";
import { Girl_2023_ID } from "config/CONSTANTS";
import { uploadImage, singUpForm } from "services/vote/2023girl";
import { useForm } from "react-hook-form";
import Modal from "components/vote/Modal";
import Alert from "components/vote/Alert";
import CloseButton from "components/vote/CloseButton";
import styled from "styled-components";
import { isMobile, isAndroid } from "react-device-detect";
import Loading from "components/vote/Loading"
import { noticeActiveStore } from "stores/noticeActive.js"
import { showMenuStore } from "stores/showMenu.js"

const SignUpForm = styled.div`
  position: relative;
  border-radius: 40px;
  font-family: Noto Sans TC;
  background: #FFF;
  height: 90vh;
  width: 46.5vw;
  min-width: 610px;
  border: 6px solid #FF55B3;
  padding: 80px 8px 80px 48px;
  overflow-y: auto;
  @media (max-width: 640px) {
    ${isMobile? 'height: 80vh;' : 'height: 88vh;'}
    width: 88vw;
    min-width: 200px;
    border-radius: 20px;
    border-width: 4px;
    ${isMobile && !isAndroid? 'padding: 40px 17px;' : 'padding: 40px 0px 40px 17px;'}
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    color: #000;
    letter-spacing: 0.9px;
    margin-bottom: 8px;
    @media (max-width: 640px) {
      font-size: 16px;
      letter-spacing: 0.8px;
    }
  }
  .addDot::before {
    content: "*";
    margin-left: 2px;
    color: #FF55B3;
  }
  .errorMsg {
    display: block;
    color: rgb(239 68 68);
    margin: 0px auto -10px 16px;
    font-size: 14px;
  } 
  .inputFrame {
    display: flex;
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #FFF;
    outline: none;
    background: #383EFF33;
    color: #383EFF;
    font-size: 16px;
    font-weight: 400;
    border-radius: 20px;
    @media (max-width: 640px) {
      font-size: 14px;
      padding: 11px 16px;
    }
    &::placeholder {
      color: #808080;
    }
    &:focus {
      border: 1px solid #383EFF66;
    }
    &:disabled {
      background: #E6E6E6;
      color: #999;
    }
  }
  .closeBtn {
    position: absolute;
    top: 5px;
    right: -15px;
    // top: 6.5vh;
    // right: max(80px, calc(50vw - 275px));
    svg {
      width: 60px;
      height: 60px;
    }
    @media (max-width: 640px) {
      top: 6.5vh;
      right: 8vw;
      svg {
        width: 40px;
        height: 40px;
      }
    }
  }
  
  &::-webkit-scrollbar {
    width: 40px;
    @media (max-width: 640px) {
      width: 20px;
    }
  }
  &::-webkit-scrollbar-button {
    display: none;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track-piece {
    background: transparent;
    margin-top: 50px;
    @media (max-width: 640px) {
      margin-top: 30px;
      margin-bottom: 10px;
    }
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: #D7D7D7;
    border: 16px solid transparent;
    background-clip: padding-box;
    @media (max-width: 640px) {
      border-width: 8px;
      border-radius: 10px;
    }
  }


  .uploadWrapper {
    text-align: center;
    padding: 24px 0;
    width: 264px;
    background: #FFF;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
    &:hover {
      background: #383EFF;
      svg path {
        fill: #FFF;
      }
      .uploadTitle {
        color: #FFF;
      }
      .uploadDes {
        color: #FFF500;
      }
    }
    svg {
      width: 32px;
      height: 23px;
      margin: auto;
    }
    svg path {
      fill: #383EFF;
    }
  }
  .uploadTitle {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    padding-top: 8px;
    padding-bottom: 10px;
  }
  .uploadDes {
    color: #FF55B3;
    font-size: 12px;
    font-weight: 500;

  }
  .signUpLink {
    color: #383EFF;
    &:hover {
      text-decoration-line: underline;
    }
  }
  .checkBoxStyle {
    display: block;
    position: relative;
    padding-left: 8px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: absolute;
      top: 4px;
      left: -5px;
      height: 13px;
      width: 13px;
      background-color: #fff;
      border-radius: 2px;
      border: 1.5px black solid;
      @media (max-width: 640px) {
        left: 10px;
      }
    }

    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }
    
    input:checked ~ .checkmark:after {
      display: block;
    }
    .checkmark:after {
      left: 3px;
      top: 0px;
      width: 5px;
      height: 9px;
      border: solid #383EFF;
      border-width: 0 2.5px 2.5px 0;
      -webkit-transform: rotate(35deg);
      -ms-transform: rotate(35deg);
      transform: rotate(35deg);
    }
    label {
      display: block;
      font-weight: 500;
      color: #000;
      font-size: 14px;
      margin-left: -15px;
      padding-left: 20px;
      @media (max-width: 640px) {
        margin-left: 5px;
      }
    }
  }
  .imageStyle {
    margin: auto;
    width: 296px;
    height: 296px;
  }
  .reUpload {
    position: absolute;
    padding: 8px 0 16px 0;
    bottom: 12px;
    svg {
      display: none;
    }
  }
`;

const MyProfile = (props) => {
  const { userSession, setToggleMyProfileModal, profile } = props;
  const [judgeStatusText, setJudgeStatusText] = useState([]);
  const [isShowAlertModal, setShowAlertModal] = useState(false);
  const [image1, setImage1] = useState([]);
  const [image2, setImage2] = useState([]);
  const [image3, setImage3] = useState([]);
  const [image1Url, setImage1Url] = useState("");
  const [image2Url, setImage2Url] = useState("");
  const [image3Url, setImage3Url] = useState("");
  const [singUpErrorMessage, setSingUpErrorMessage] = useState([]);
  const [isLoading, setLoading] = useState(false)
  const { setIsActive } = noticeActiveStore()
  const { setShowMenu } = showMenuStore()
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
      switch (profile.judgeStatus) {
          case "accepted":
            setJudgeStatusText(["通過審核", true]);
            break;
          case "judging":
            setJudgeStatusText(["等待審核", true]);
            break;
          case "rejected":
            setJudgeStatusText(["請重新提交報名資料", false]);
            break;
          case "ban":
            setJudgeStatusText(["禁止報名", true]);
            break;
          default:
            setJudgeStatusText(["default", false]);
            break;
        }
      
      setValue("nickname", profile.nickname);
      setValue("email", profile.email);
      setValue("phone", profile.phone);
      setValue("intro", profile.intro);
      setValue("ig", profile.socialLinks.instagram || '');
      setValue("lineId", profile.socialLinks.line || '');
      setValue("tikTok", profile.socialLinks.tikTok || '');
      setValue("goddess", profile.info.心目中的女神 || '');
      setValue("picture1", profile.playerPhotos[0]);
      setValue("picture2", profile.playerPhotos[1]);
      setValue("picture3", profile.playerPhotos[2]);
      setImage1Url(profile.playerPhotos[0]);
      setImage2Url(profile.playerPhotos[1]);
      setImage3Url(profile.playerPhotos[2]);
  }, [profile, setValue, setJudgeStatusText]);

  const uploadImageModalHandler = () => {
    setShowAlertModal((preState) => !preState);
  };
  const scrollToHandler = (id) => {
    const violation = document.getElementById(id);
   setTimeout(
    () => {
      window.scrollTo({
      top: violation.offsetTop,
      behavior:"smooth"
      })
    },100);
  }
  const uploadImg = async (e, type) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    if (file) {
      if (file.size > 3000000) {
        setShowAlertModal(true);
        setSingUpErrorMessage([
          "上傳圖片檔案過大",
          "抱歉上傳圖片不可超過 3MB 喔，請重新上傳檔案，謝謝!",
          false,
        ]);
        return false;
      }
      switch (type) {
        case "image1":
          // for 縮圖顯示
          const image1 = await readFileAsync(file);
          setImage1([image1]);
          // for 縮圖顯示 end
          uploadImage(formData)
            .then((res) => {
              setImage1Url(res.result);
              profile.playerPhotos[0] = res.result
            })
            .catch((err) => {
              console.log("axios err=", err);
            });
          break;
        case "image2":
          const image2 = await readFileAsync(file);
          setImage2([image2]);

          uploadImage(formData)
            .then((res) => {
              setImage2Url(res.result);
              profile.playerPhotos[1] = res.result
            })
            .catch((err) => {
              console.log("axios err=", err);
            });
          break;
        case "image3":
          const image3 = await readFileAsync(file);
          setImage3([image3]);

          uploadImage(formData)
            .then((res) => {
              setImage3Url(res.result);
              profile.playerPhotos[2] = res.result
            })
            .catch((err) => {
              console.log("axios err=", err);
            });
          break;
        default:
          break;
      }
    }
  };
  const readFileAsync = (e) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        generateFromImage(reader.result, 300, 300, 1, (imgdata) => {
          resolve({
            id: performance.now(),
            url: imgdata,
            type: "image",
          });
        });
      };
      reader.onerror = reject;
      reader.readAsDataURL(e);
    });
  };

  const generateFromImage = (
    img,
    MAX_WIDTH = 300,
    MAX_HEIGHT = 300,
    quality = 1,
    callback
  ) => {
    let canvas = document.createElement("canvas");
    let image = new Image();

    image.onload = () => {
      let width = image.width;
      let height = image.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, width, height);
      let dataUrl = canvas.toDataURL("image/jpeg", quality);
      callback(dataUrl);
    };
    image.src = img;
  };

  const onSubmit = (data) => {
    const { email, nickname, phone, intro, goddess, tikTok, lineId, ig } = data;
    const playerPhotos = [image1Url, image2Url, image3Url];

    const singUpFormData = {
      gameId: Girl_2023_ID,
      userId: userSession,
      nickname,
      email,
      phone,
      intro,
      playerPhotos,
      socialLinks: { line: lineId, tikTok, instagram: ig },
      info: { 心目中的女神: goddess }
    };
    setLoading(true)
    singUpForm(singUpFormData)
      .then((res) => {
        if (res.playerId) {
          setShowAlertModal(true);
          profile.judgeStatus = 'judging'
          setJudgeStatusText(["等待審核", true]);
          setSingUpErrorMessage([
            "報名成功",
            "請等候米特管理員審核喔，謝謝！",
             true,
          ]);
        }
        setLoading(false)
        return;
      })
      .catch((err) => {
        if (err) {
          setShowAlertModal(true);
          setSingUpErrorMessage([
            "報名失敗",
            err.error + "，若有任何疑問請聯絡官方人員，謝謝!",
            false,
          ]);
        }
        setLoading(false)
        return;
      });
  };

  return (
    <>
    <div className="relative">
      <CloseButton
        size={window.innerWidth >= 640 ? "60px" : "40px"}
        btnClass={`absolute sm:top-[8px] sm:right-[8px] top-[6px] right-[6px]`}
        fill={"#FF55B3"}
        handleClose={() => setToggleMyProfileModal(false)}/>
      {profile && (
        <SignUpForm>
          <div className="w-full relative">
            <div
              className="sm:mb-[48px] mb-[40px] text-center sm:text-[32px] text-[24px] text-pink-11 font-black whitespace-pre-line">
              2023 Meteor{"\u000A"}惹不起的校園女神報名
            </div>
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              {judgeStatusText[0] !== 'default' && (
                <div className="sm:w-[304px] w-[75.5vw] mx-auto py-[8px] rounded-full text-center sm:text-[18px] text-[16px] text-[#FFF] bg-blue-11  font-bold mt-[-24px]">
                報名狀態：{judgeStatusText[0]}
                </div>
              )}
              <div className="relative">
                <label className="flex text-base" htmlFor="nickname">
                  <span className="title addDot">
                    暱稱/英文名 (票選活動使用)
                  </span>
                </label>
                <input
                  id="nickname"
                  name="nickname"
                  type="text"
                  autoComplete="nickname"
                  className="inputFrame"
                  placeholder="暱稱最長5個字"
                  {...register("nickname", {
                    disabled: judgeStatusText[1],
                    required: true,
                    maxLength: 5,
                    onChange: (e) => {
                      profile.nickname = e.target.value
                    }
                  })}
                />
                {errors.nickname && (
                  <div
                    className="errorMsg">
                    請輸入五個字以內的暱稱
                  </div>
                )}
              </div>
              <div className="relative">
                <label
                  htmlFor="email-address"
                  className="flex text-base">
                  <span className="title addDot">
                    信箱
                  </span>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  placeholder="請輸入電子信箱"
                  {...register("email", {
                    disabled: judgeStatusText[1],
                    required: true,
                    pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/,
                    onChange: (e) => {
                      profile.email = e.target.value
                    }
                  })}
                />
                {errors.email && (
                  <div
                    className="errorMsg">
                    請輸入電子信箱（範例：xxxx@xxx.xxx）
                  </div>
                )}
              </div>
              <div className="relative">
                <label
                  htmlFor="phone"
                  className="flex text-base">
                  <span className="title addDot">
                    連絡電話(僅做活動得獎聯繫之用)
                  </span>
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="text"
                  autoComplete="phone"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  {...register("phone", {
                    disabled: judgeStatusText[1],
                    required: true,
                    pattern: /^(09\d{2}-?\d{3}-?\d{3})|(\d{2}-?\d{4}-?\d{4})|(\+\d{5,15})$/,
                    onChange: (e) => {
                      profile.phone = e.target.value
                    }
                  })}
                />
                {errors.phone && (
                  <div
                    className="errorMsg">
                    請輸入連絡電話
                  </div>
                )}
              </div>
              <div className="relative">
                <label
                  htmlFor="lineId"
                  className="flex text-base">
                  <span className="title addDot">
                    LINE ID(僅活動過程中若需與本人聯繫之用)
                  </span>
                </label>
                <input
                  id="lineId"
                  name="lineId"
                  type="text"
                  autoComplete="lineId"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  placeholder="範例: meteor.tw"
                  {...register("lineId", {
                    disabled: judgeStatusText[1],
                    required: true,
                    onChange: (e) => {
                      profile.socialLinks.line = e.target.value
                    }
                  })}
                />
                {errors.lineId && (
                  <div
                    className="errorMsg">
                    請輸入LINE ID
                  </div>
                )}
              </div>
              <div className="relative">
                <label
                  htmlFor="ig"
                  className="flex text-base">
                  <span className="title">
                    Instagram帳號 (選填/會顯示在個人票選頁面)
                  </span>
                </label>
                <input
                  id="ig"
                  name="ig"
                  type="text"
                  autoComplete="ig"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  placeholder={`${
                    judgeStatusText[1] ? "" : "範例: meteor.tw"
                  }`}
                  {...register("ig", {
                    disabled: judgeStatusText[1],
                    onChange: (e) => {
                      profile.socialLinks.instagram = e.target.value
                    }
                  })}
                />
              </div>
              <div className="relative">
                <label
                  htmlFor="tikTok"
                  className="flex text-base">
                  <span className="title">
                    TikTok帳號 (選填/會顯示在個人票選頁面)
                  </span>
                </label>
                <input
                  id="tikTok"
                  name="tikTok"
                  type="text"
                  autoComplete="tikTok"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  placeholder={`${
                    judgeStatusText[1] ? "" : "範例: meteor.tw"
                  }`}
                  {...register("tikTok", {
                    disabled: judgeStatusText[1],
                    onChange: (e) => {
                      profile.socialLinks.tikTok = e.target.value
                    }
                  })}/>
              </div>
              <div className="relative">
                <label
                  htmlFor="goddess"
                  className="flex text-base">
                  <span className="title addDot">
                    心目中的女神
                  </span>
                </label>
                <input
                  id="goddess"
                  name="goddess"
                  type="text"
                  autoComplete="goddess"
                  placeholder="字數最多20字"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  {...register("goddess", {
                    disabled: judgeStatusText[1],
                    required: true,
                    maxLength: 20,
                    onChange: (e) => {
                      profile.info.心目中的女神 = e.target.value
                    }
                  })}
                />
                {errors.goddess && (
                  <div
                    className="errorMsg">
                    請輸入心目中的女神 (最多20字)
                  </div>
                )}
              </div>

              <div className="relative">
                <label
                  htmlFor="intro"
                  className="flex text-base">
                  <span className="title addDot">
                    女神定義
                  </span>
                </label>
                <textarea
                  id="defineGoddess"
                  name="defineGoddess"
                  type="text"
                  autoComplete="defineGoddess"
                  className={`inputFrame ${
                    judgeStatusText[1] ? "bg-gray-2" : ""
                  }`}
                  rows="4"
                  placeholder="字數最多50字"
                  {...register("intro", {
                    disabled: judgeStatusText[1],
                    required: true,
                    maxLength: 50,
                    onChange: (e) => {
                      profile.intro = e.target.value
                    }
                  })}
                ></textarea>
                {errors.intro && (
                  <small className="errorMsg">
                    請輸入女神定義 (最多50字)
                  </small>
                )}
              </div>
              <div className={` relative flex justify-center bg-grey-lighter mb-4`}>
                { !judgeStatusText[1] && (
                <label
                  className={`uploadWrapper ${image1Url ? 'reUpload' : '' }`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                  </svg>
                  <div className="uploadTitle">
                    {judgeStatusText[0] === 'default' ? "上傳本人照片 1" : image1Url ? "重新上傳本人照片 1" : "新增本人照片 1"}
                  </div>
                  <div className="uploadDes">
                    請上傳正方形(1:1)照片，需露出清晰五官
                  </div>
                  <input
                    {...register("picture1", { disabled: judgeStatusText[1] })}
                    className="hidden block w-full text-sm text-slate-500
                                file:mr-4 file:py-2 file:px-4
                                file:rounded-full file:border-0
                                file:text-sm file:font-semibold
                                file:bg-violet-50 file:text-violet-700
                                hover:file:bg-violet-100"
                    type="file"
                    name="picture1"
                    onChange={(e) => uploadImg(e, "image1")}
                  />
                </label>)}
                {image1Url && (
                  <img className="imageStyle" src={image1Url} alt="" />
                )}
              </div>
              {errors.picture1 && (
                <div className="flex justify-center relative left-12px top-N18px text-red-500 text-xs italic">
                  請上傳本人照片 1
                </div>
              )}

              <div className="flex justify-center bg-grey-lighter mb-4 relative">
                { !judgeStatusText[1] && (
                <label
                  className={`uploadWrapper ${image2Url ? 'reUpload' : '' }`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                  </svg>
                  <div className="uploadTitle">
                    {judgeStatusText[0] === 'default' ? "上傳本人照片 2" : image2Url ? "重新上傳本人照片 2" : "新增本人照片 2"}
                  </div>
                  <div className="uploadDes">
                    請上傳正方形(1:1)照片
                  </div>
                  <input
                    {...register("picture2", { disabled: judgeStatusText[1] })}
                    className="hidden block w-full text-sm text-slate-500
                                file:mr-4 file:py-2 file:px-4
                                file:rounded-full file:border-0
                                file:text-sm file:font-semibold
                                file:bg-violet-50 file:text-violet-700
                                hover:file:bg-violet-100"
                    type="file"
                    name="picture2"
                    onChange={(e) => uploadImg(e, "image2")}
                  />
                </label>)}
                {image2Url && (
                  <img className="imageStyle" src={image2Url} alt="" />
                )}
              </div>
              
             <div className="flex justify-center bg-grey-lighter mb-4 relative">
                 { !judgeStatusText[1] && (<label
                  className={`uploadWrapper ${image3Url ? 'reUpload' : '' }`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                  </svg>
                  <div className="uploadTitle">
                    {judgeStatusText[0] === 'default' ? "上傳本人照片 3" : image3Url ? "重新上傳本人照片 3" : "新增本人照片 3"}
                  </div>
                  <div className="uploadDes">
                    請上傳正方形(1:1)照片
                  </div>
                  <input
                    {...register("picture3", { disabled: judgeStatusText[1] })}
                    className="hidden block w-full text-sm text-slate-500
                                file:mr-4 file:py-2 file:px-4
                                file:rounded-full file:border-0
                                file:text-sm file:font-semibold
                                file:bg-violet-50 file:text-violet-700
                                hover:file:bg-violet-100"
                    type="file"
                    name="picture3"
                    onChange={(e) => uploadImg(e, "image3")}
                  />
                </label>)}
                {image3Url && (
                  <img className="imageStyle" src={image3Url} alt="" />
                )}
              </div> 
              
              <div>
                <div className="flex items-center checkBoxStyle">
                  <input
                    id="agree"
                    name="agree"
                    type="checkbox"
                    defaultChecked={judgeStatusText[1]}
                    {...register("agree", {
                      disabled: judgeStatusText[1],
                      required: true })}
                  />
                  <span className="checkmark"></span>
                  <label
                    className="relative"
                    htmlFor="agree">
                    我已了解本活動須為Meteor會員本人報名且為本人之照片，一旦經查證或告發假借不真實身分參加本活動，將取消其參加活動資格，並追究法律責任。
                  </label>
                </div>
                <div className="flex items-center sm:mt-[12px] mt-[16px] checkBoxStyle">
                  <input
                    id="agree2"
                    name="agree2"
                    type="checkbox"
                    className="text-indigo-600 focus:ring-indigo-500 border-gray-300"
                    defaultChecked={judgeStatusText[1]}
                    {...register("agree2", {
                      disabled: judgeStatusText[1],
                      required: true })}
                  />
                  <span className="checkmark"></span>
                  <label
                    className="relative ml-2 block font-medium text-[#000] text-[14px]"
                    htmlFor="agree2"
                  >
                    我已閱讀
                    <span
                      className="signUpLink"
                      onClick={() => {
                        setIsActive(true);
                        setToggleMyProfileModal(false);
                        setShowMenu(false);
                        scrollToHandler('notices');
                      }}>
                      活動注意事項
                    </span>
                    及
                    <a
                      href="https://wooo.tw/ys57Ppe"
                      className="signUpLink"
                      target="_blank"
                      rel="noreferrer"
                    >
                      個人資料蒐集同意書
                    </a>
                    ，並同意上傳照片後同時授權主辦單位有永久、無償利用，利用方式包括但不限於重製、散布、公開傳輸、公開播送、編輯、改作等一切必要權利。
                  </label>
                </div>
                {(errors.agree || errors.agree2) && (
                  <div className="errorMsg">
                    請勾選注意事項
                  </div>
                )}
              </div>

              {!judgeStatusText[1] && (
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="py-[6px] px-[20px] bg-pink-11 text-[20px] font-black rounded-12px text-[#FFF] bg-pink-11 cursor:point">
                    送出報名
                  </button>
                </div>
              )}
            </form>
            <div className="w-full font-medium text-[14px] sm:mt-20px mt-[24px] text-center">
              報名時遇到問題嗎？
              <a
                href="https://m.me/MeteorApp"
                className="signUpLink"
                target="_blank"
                rel="noreferrer"
              >
                請聯絡粉絲專頁！
              </a>
            </div>
          </div>
        </SignUpForm>
      )}

      <Modal
        handleClose={() => uploadImageModalHandler(false)}
        isOpen={isShowAlertModal}
      >
        <Alert
          title={singUpErrorMessage[0]}
          content={singUpErrorMessage[1]}
          success={singUpErrorMessage[2]}
          uploadImageModalHandler={uploadImageModalHandler}
        />
      </Modal>
    </div>
    {isLoading ? <Loading
      color="#FFF500"
      size="80px"/> : null}
    </>
  );
};

export default MyProfile;
